"use strict";
// Copyright (c) StrangeBee 2023
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParentController_1 = __importDefault(require("../ParentController"));
class ForgotPasswordController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            get: '/v1/admin/config/forgotPassword',
        };
    }
    list() {
        throw new Error("Can't list forgotPassword");
    }
    count() {
        throw new Error("Can't count forgotPassword");
    }
    create({}) {
        throw new Error("Can't create forgotPassword!");
    }
    // eslint-disable-next-line
    edit(data) {
        return this.manager.put({ url: this.endpoints.get }, data);
    }
    delete() {
        throw new Error("Can't delete forgotPassword!");
    }
    getConfig() {
        return this.manager.get({
            url: this.endpoints.get,
        });
    }
}
exports.default = ForgotPasswordController;
